import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { getFirestore } from 'firebase/firestore/lite'

const firebaseConfig = {
  apiKey: 'AIzaSyDhqWB-VbK9LGOL9ePBUcOXIx1u2WAjXeA',
  authDomain: 'portfolio-19176.firebaseapp.com',
  projectId: 'portfolio-19176',
  storageBucket: 'portfolio-19176.appspot.com',
  messagingSenderId: '515781250123',
  appId: '1:515781250123:web:a2a50bb2b04ad3cabb51ce',
  measurementId: 'G-EG8DHLQL9G',
}
const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
const provider = new GoogleAuthProvider()
export const db = getFirestore(app)
export const storage = getStorage(app)

export const signInWithGoogle = () => signInWithPopup(auth, provider)
